<div class="task-drawer" [formGroup]="sectionForm">
  @if (isLoading) {
    <app-panel-loading-skeleton entityLabel="task"
      [sidebarSections]="[{ title: 'Status & Priority', fields: ['Status', 'Priority'] }, { title: 'Dates & Milestones', fields: ['Due Date', 'Milestone', 'Created On'] }, { title: 'People', fields: ['Assignee', 'Observers', 'Participants'] }]"
      infoTitle="Task Information" [infoFields]="['Status', 'Priority', 'Deadline', 'Stage']"
      [tabs]="['Details', 'Checklist', 'Attachments', 'Comments', 'History']"
      (closeRequested)="close()"></app-panel-loading-skeleton>
  }
  <div class="task-drawer-layout">
    <!-- LEFT: SIDEBAR (256px, collapsible) -->
    <app-task-sidebar [taskForm]="sectionForm" [projectName]="getProjectName()" [taskId]="taskID || model?.id"
      [milestones]="milestones" [selectedMilestone]="getSelectedMilestone()"
      [assignees]="model?.responsible_persons || []" [observers]="model?.observers || []"
      [participants]="model?.participants || []" [tags]="taskTags" [completionPercentage]="completionPercentage"
      [createdOn]="model?.created_at" [isCollapsed]="isSidebarCollapsed" [isReadOnly]="false " [isViewMode]="true"
      [statuses]="statuses" [selectedStatus]="model?.status_label" [isLocked]="isLocked"
      (onCollapse)="isSidebarCollapsed = $event"
      (onSearch)="handleSearch($event)" (fieldChange)="handleFieldChange($event)"
      (statusChange)="onChangeStatus($event)" (milestoneSelected)="handleMilestoneSelect($event)"
      (milestoneRemoved)="handleMilestoneRemove()"
      (assigneeSelectorOpened)="openUserPopup($event, CONST_RESPONSIBLE_PERSON_TYPE)"
      (assigneeSelected)="handleAssigneeSelected($event)" (assigneeRemoved)="removeAssignee($event)"
      (observerSelectorOpened)="openUserPopup($event, CONST_OBSERVER_TYPE)"
      (observerSelected)="handleObserverSelected($event)" (observerRemoved)="removeObserver($event)"
      (participantSelectorOpened)="openUserPopup($event, CONST_PARTICIPANT_TYPE)"
      (participantSelected)="handleParticipantSelected($event)" (participantRemoved)="removeParticipant($event)">
    </app-task-sidebar>

    <!-- RIGHT: MAIN CONTENT AREA -->
    <div class="task-main-area">
      <!-- HEADER -->
      <app-task-header [isEdit]="true" [isViewMode]="true" [taskTitle]="model?.name" [moduleLabel]="getModuleLabel()"
        [projectName]="getProjectName()" [projectId]="getRecordNumber()" [recordRoute]="getRecordRoute()" [status]="getStatusFromForm()"
        [milestone]="getSelectedMilestone()" [isFullscreen]="isFullscreen" [isFormValid]="true"
        [searchQuery]="searchQuery" [templates]="[]" [hasTemplates]="false" [stages]="stages"
        [selectedStage]="model?.stage" [hasStages]="!!model?.stage || (stages && stages.length > 0)" [isHighPriority]="model?.priority == 3"
        [priority]="model?.priority || 2" [statuses]="statuses" [selectedStatus]="model?.status_label"
        [hasStatuses]="statuses && statuses.length > 0" [showStatusDropdown]="true" [showMarkComplete]="true"
        [showPdfExport]="true" [showCopy]="true" [showDelete]="true" [markCompletePermission]="changeStatusTaskPermission"
        [pdfExportPermission]="exportPDFPermission" [deletePermission]="deleteTaskPermission"
        [copyPermission]="'TASK-COPY-TASKS'"
        [editPermission]="editTaskPermission"
        [statusChangePermission]="changeStatusTaskPermission" [stageChangePermission]="changeStageTaskPermission"
        [isLocked]="isLocked" [showFlag]="true" [flagged]="!!model?.is_flagged" [flagText]="model?.flag_text || ''" (flagSave)="saveFlag($event)"
        (save)="close()" (close)="close(loadListingOnClose)" (delete)="onConfirmation()" (recordLinkClick)="close(loadListingOnClose)"
        (searchToggle)="isSearchOpen = $event" (searchChange)="searchQuery = $event"
        (fullscreenToggle)="isFullscreen = $event" (templateSelect)="close()" (stageSelect)="addStage($event)"
        (priorityToggle)="togglePriority()" (statusSelect)="onChangeStatus($event)" (markComplete)="markAsComplete()" (copy)="openCopyTaskDialog()"
        (pdfExport)="generatePDF()" (edit)="editTask()" (lockToggle)="toggleLock()">
      </app-task-header>

      <!-- MAIN CONTENT WITH TABS -->
      <app-task-main-content [taskForm]="sectionForm" [selectedMilestone]="getSelectedMilestone()"
        [checklistCount]="getChecklistCount()" [attachmentsCount]="model?.relations?.attach_files?.length || 0"
        [commentsCount]="taskComments.length" [activeTab]="activeTabIndex" [isTaskModule]="false" [modulesList]="[]"
        [searchParams]="{}" [selectedItem]="{}" [showSearchInput]="false" [mentions]="[]" [isViewMode]="true"
        [showTimeElapsed]="true" [isLocked]="isLocked" (tabChange)="handleTabChange($event)" (editDescription)="handleEditDescription()" (descriptionSave)="saveDescription($event)"
        (removeMilestone)="handleMilestoneRemove()">

        <!-- DETAILS TAB CONTENT -->
        <div details-tab>
          <app-task-details-tab [taskForm]="sectionForm" [status]="getStatusFromForm()"
            [statuses]="statuses" [statusId]="model?.status_label?.id"
            [priority]="getPriorityText(model?.priority || 2)" [dueDate]="model?.due_date" [stage]="model?.stage?.name"
            [flagReason]="model?.is_flagged ? (model?.flag_text || '') : ''"
            [unflagReason]="!model?.is_flagged ? (model?.unflag_text || '') : ''"
            [canEditFlagReason]="true" (flagReasonSave)="saveFlagReason($event)"
            [assignee]="model?.created_by?.full_name" [createdDate]="model?.created_at"
            [description]="model?.description" [isViewMode]="true">
          </app-task-details-tab>
        </div>

        <!-- CHECKLIST TAB CONTENT -->
        <div checklist-tab>
          <div class="tab-content-wrapper">
            <app-task-checklists [model]="model" [taskId]="taskID" [checkLists]="model?.check_list"
              [isLocked]="isLocked" (callback)="handleChecklistChange($event)">
            </app-task-checklists>
          </div>
        </div>

        <!-- ATTACHMENTS TAB CONTENT -->
        <div attachments-tab>
          <div class="tab-content-wrapper">
            <app-task-attachments
              [module_id]="TASK_MODULE_ID"
              [attachable_id]="taskID?.toString() || ''"
              [folder_id]="8010"
              [isLocked]="isLocked">
            </app-task-attachments>
          </div>
        </div>

        <!-- COMMENTS TAB CONTENT -->
        <div comments-tab>
          <div class="tab-content-wrapper">
            @if (model) {
              <app-task-comments [model]="model" [isActiveTab]="activeTabIndex === 3"
                [isLocked]="isLocked" (messageAdded)="handleCommentAdded()" (closeRequest)="handleCommentClose($event)">
              </app-task-comments>
            }
          </div>
        </div>

        <!-- TIME ELAPSED TAB CONTENT -->
        <div time-elapsed-tab>
          <div class="tab-content-wrapper">
            @if (model) {
              <app-task-time-elapsed [model]="model">
              </app-task-time-elapsed>
            }
          </div>
        </div>

        <!-- HISTORY TAB CONTENT -->
        <div history-tab>
          @if (model) {
            <app-task-history-tab [history]="taskHistory" [taskId]="taskID?.toString()" [taskModel]="model">
            </app-task-history-tab>
          }
        </div>
      </app-task-main-content>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="task-footer">
    <!-- Left Section: Quick Actions -->
    <div class="footer-left">
      <button type="button" mat-button class="footer-action-btn" (click)="toggleFavorite()"
        [attr.aria-label]="isFavorite ? 'Remove from favorites' : 'Add to favorites'"
        [matTooltip]="isFavorite ? 'Remove from favorites' : 'Add to favorites'"
        [disabled]="isLocked" [ngClass]="{'permission-disabled': isLocked}">
        <mat-icon>{{ isFavorite ? 'star' : 'star_border' }}</mat-icon>
        <span class="btn-text">{{ isFavorite ? 'Favorited' : 'Add to Favorites' }}</span>
      </button>

      <span class="footer-separator">|</span>

      <button type="button" mat-button class="footer-action-btn" (click)="setReminder()"
        [attr.aria-label]="'Set reminder'" matTooltip="Set reminder"
        [disabled]="isLocked" [ngClass]="{'permission-disabled': isLocked}">
        <mat-icon>notifications_none</mat-icon>
        <span class="btn-text">Set Reminder</span>
      </button>
    </div>

    <!-- Right Section: Primary Actions -->
    <div class="footer-right">
      <!-- Delete Button -->
      <button type="button" mat-stroked-button class="footer-delete-btn" [appPermission]="deleteTaskPermission"
        (click)="onConfirmation()" [disabled]="isLocked" [ngClass]="{'permission-disabled': isLocked}"
        [attr.aria-label]="'Delete task'">
        <mat-icon>delete</mat-icon>
        <span class="btn-text">Delete</span>
      </button>

      <!-- Close Button -->
      <button type="button" mat-raised-button class="footer-save-btn" (click)="close(loadListingOnClose)"
        [attr.aria-label]="'Close'">
        <span class="btn-text">Close</span>
      </button>
    </div>
  </div>
</div>